module.exports = __webpack_public_path__ + "./assets/icons/linkedin.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/linkedinIcon.svg
// module id = 163
// module chunks = 0 1